import React, { Fragment } from 'react';

import { Link } from 'react-router-dom';

import PerfectScrollbar from 'react-perfect-scrollbar';
import { Hidden, Drawer, Button } from '@material-ui/core';

import { connect } from 'react-redux';

import ChevronLeftRoundedIcon from '@material-ui/icons/ChevronLeftRounded';

import SidebarHeader from '../../layout-components/SidebarHeader';
import SidebarMenu from '../../layout-components/SidebarMenu';
import SidebarRail from '../../layout-components/SidebarRail';

import projectLogo from '../../assets/images/escolastia/logo-letras-negro-small.png';

import navItems from './navItems';

import {
  setSidebarToggleMobile,
  setSidebarToggle
} from '../../reducers/ThemeOptions';

const Sidebar = props => {
  const {
    setSidebarToggleMobile,
    sidebarToggleMobile,
    setSidebarToggle,
    sidebarToggle
  } = props;

  const closeDrawerMobile = () => setSidebarToggleMobile(!sidebarToggleMobile);
  const collapseSidebar = () => setSidebarToggle(true);

  // Menú completo (con etiquetas) usado tanto en mobile como en el panel
  // expandido de escritorio. `onNavigate` cierra el panel al seleccionar.
  const renderFullMenu = onNavigate =>
    navItems.map(list => (
      <SidebarMenu
        component="div"
        key={list.label}
        pages={list.content}
        title={list.label}
        onNavigate={onNavigate}
      />
    ));

  return (
    <Fragment>
      {/* Mobile: drawer temporal, solo por debajo del breakpoint sm. */}
      <Hidden smUp>
        <Drawer
          anchor="left"
          open={sidebarToggleMobile}
          onClose={closeDrawerMobile}
          variant="temporary"
          elevation={4}
          className="app-sidebar-wrapper-lg">
          <SidebarHeader />
          <PerfectScrollbar>{renderFullMenu()}</PerfectScrollbar>
        </Drawer>
      </Hidden>

      {/* Escritorio (sm+): riel compacto + panel flotante al expandir. */}
      <Hidden xsDown>
        <SidebarRail />

        <Drawer
          anchor="left"
          open={!sidebarToggle}
          onClose={collapseSidebar}
          variant="temporary"
          elevation={6}
          classes={{ paper: 'app-sidebar-expanded' }}>
          <div className="app-sidebar-expanded-header">
            <Link to="/dashboard">
              <img
                className="app-sidebar-logo"
                alt="ESCOLASTIA - Administrador"
                src={projectLogo}
              />
            </Link>
          </div>
          <PerfectScrollbar
            className="app-sidebar-expanded-scroll"
            options={{ wheelPropagation: false }}>
            {renderFullMenu(collapseSidebar)}
          </PerfectScrollbar>
          <div className="app-sidebar-expanded-footer">
            <Button
              fullWidth
              disableRipple
              onClick={collapseSidebar}
              startIcon={<ChevronLeftRoundedIcon />}>
              Compactar menú
            </Button>
          </div>
        </Drawer>
      </Hidden>
    </Fragment>
  );
};

const mapStateToProps = state => ({
  sidebarToggle: state.ThemeOptions.sidebarToggle,
  sidebarToggleMobile: state.ThemeOptions.sidebarToggleMobile
});

const mapDispatchToProps = dispatch => ({
  setSidebarToggleMobile: enable => dispatch(setSidebarToggleMobile(enable)),
  setSidebarToggle: enable => dispatch(setSidebarToggle(enable))
});

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);
